module.exports = __webpack_public_path__ + "media/images/icons/SVG/043-8814d37e3b2d147e421da3cea8675b1e.svg";